"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRFC3339 = exports.parseFullDate = exports.formatRFC3399 = exports.formatPeriodDate = exports.formatPeriodHourMin = exports.formatPeriod = exports.formatFullDateTime = exports.formatDateWithDayName = exports.formatHumanFullDate = exports.formatFullDate = exports.formatEnDayName = exports.formatDayName = exports.formatHourMin = exports.formatWithLocale = void 0;
// @see https://date-fns.org/docs/format
// このオンラインフォーマッターもとても便利
// http://www.sdfonlinetester.info/
// TODO: Formatterにしたい
const date_fns_1 = require("date-fns");
const en_US_1 = __importDefault(require("date-fns/locale/en-US"));
const ja_1 = __importDefault(require("date-fns/locale/ja"));
// @see https://date-fns.org/v2.28.0/docs/format
// DateのEncode(Date→string) / Decode(string→Date)を行う
const FULL_DATE = 'yyyy-MM-dd';
const HUMAN_FULL_DATE = 'yyyy年M月d日(EEE)';
const DATE_WITH_DAY_NAME = 'M月d日(EEE)';
const DAY_NAME = 'EEE';
const HOUR_MIN = 'HH:mm';
const FULL_DATE_TIME = 'yyyy/MM/dd(EEE) HH:mm';
const formatWithLocale = (date, formatString) => {
    return (0, date_fns_1.format)(date, formatString, { locale: ja_1.default });
};
exports.formatWithLocale = formatWithLocale;
const formatHourMin = (date) => (0, exports.formatWithLocale)(date, HOUR_MIN);
exports.formatHourMin = formatHourMin;
const formatDayName = (date) => (0, exports.formatWithLocale)(date, DAY_NAME);
exports.formatDayName = formatDayName;
// workingHoursの曜日のkeyに利用(mon,tue,...)
const formatEnDayName = (date) => (0, date_fns_1.format)(date, DAY_NAME, { locale: en_US_1.default });
exports.formatEnDayName = formatEnDayName;
const formatFullDate = (date) => (0, exports.formatWithLocale)(date, FULL_DATE);
exports.formatFullDate = formatFullDate;
const formatHumanFullDate = (date) => (0, date_fns_1.format)(date, HUMAN_FULL_DATE, { locale: ja_1.default });
exports.formatHumanFullDate = formatHumanFullDate;
const formatDateWithDayName = (date) => (0, exports.formatWithLocale)(date, DATE_WITH_DAY_NAME);
exports.formatDateWithDayName = formatDateWithDayName;
const formatFullDateTime = (date) => (0, exports.formatWithLocale)(date, FULL_DATE_TIME);
exports.formatFullDateTime = formatFullDateTime;
const formatPeriod = (period, tz = null) => {
    return `${(0, exports.formatDateWithDayName)(period.start)} ${(0, exports.formatHourMin)(period.start)}~${(0, exports.formatHourMin)(period.end)}${tz ? `(${tz})` : ''}`;
};
exports.formatPeriod = formatPeriod;
const formatPeriodHourMin = (period) => {
    return `${(0, exports.formatHourMin)(period.start)}~${(0, exports.formatHourMin)(period.end)}`;
};
exports.formatPeriodHourMin = formatPeriodHourMin;
const formatPeriodDate = (period) => {
    return `${(0, exports.formatDateWithDayName)(period.start)}~${(0, exports.formatDateWithDayName)(period.end)}`;
};
exports.formatPeriodDate = formatPeriodDate;
exports.formatRFC3399 = date_fns_1.formatRFC3339;
// Parse
const parseFullDate = (string) => (0, date_fns_1.parse)(string, FULL_DATE, new Date());
exports.parseFullDate = parseFullDate;
exports.parseRFC3339 = date_fns_1.parseISO;
//# sourceMappingURL=dateCoder.js.map